import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState, type PaginationState, type SortingState } from "@tanstack/react-table";
import { formatISO } from "date-fns";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering, clientToServerSorting } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";

type Params = {
  pagination: PaginationState;
  sorting: SortingState;
  filters?: ColumnFiltersState;
  search?: string;
  start?: Date;
  end?: Date;
  preStart?: Date;
  preEnd?: Date;
};

export const useGetV4CategoryReportByCategory = () => {
  const marketPlace = useAppSelector(
    (state: { marketPlace: { marketPlace: string } }) => state.marketPlace.marketPlace,
  );

  const { start, end, preStart, preEnd } = useDates();
  return (params: Params) => {
    const cursor = params.pagination.pageIndex * params.pagination.pageSize || undefined;
    const search = params.search ? params.search.split(",") : [];

    return queryOptions({
      queryKey: [
        {
          entity: "V4CategoryReportByCategory",
          marketPlace,
          params,
          dates: { start, end, preStart, preEnd },
        },
      ],
      queryFn: async () => {
        const queryParams = {
          queries: {
            marketplace: marketPlace,
            start_date: params.start ? formatISO(params.start, { representation: "date" }) : start.format("YYYY-MM-DD"),
            end_date: params.end ? formatISO(params.end, { representation: "date" }) : end.format("YYYY-MM-DD"),
            start_date_previous:
              params.preStart ? formatISO(params.preStart, { representation: "date" }) : preStart.format("YYYY-MM-DD"),
            end_date_previous:
              params.preEnd ? formatISO(params.preEnd, { representation: "date" }) : preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(params.filters),
            cursor,
            limit: params.pagination.pageSize,
            ordering: clientToServerSorting(params.sorting),
            search: search,
          },
        };

        return await apiClient.getV4CategoryReportByCategory(queryParams);
      },
      placeholderData: keepPreviousData,
    });
  };
};

export type CategoryReportByCategoryRow = Awaited<
  ReturnType<typeof apiClient.getV4CategoryReportByCategory>
>["data"][number];
